import { useIntl } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

import Button from '@atlaskit/button/new';
import DropdownMenu, {
  DropdownItemGroup,
  DropdownItem,
} from '@atlaskit/dropdown-menu';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';

import { messages } from './group.i18n';
import { DropdownItemContent } from './group.style';

export enum Privacy {
  public = 'public',
  private = 'private',
}

export type PrivacyDropdownProps = {
  onChange: (value: Privacy | null) => void;
  value: Privacy | null;
  allowEmptyChoice?: boolean;
};

const PrivacyDropdown = ({
  value,
  onChange,
  allowEmptyChoice,
}: PrivacyDropdownProps) => {
  const { formatMessage } = useIntl();

  const getTriggerMessage = () => {
    if (value !== null) {
      return formatMessage(messages[value]);
    }

    return formatMessage(messages.privacy);
  };

  const getItem = (choice: Privacy | null, label: MessageDescriptor) => (
    <DropdownItem
      onClick={() => onChange(choice)}
      isDisabled={value === choice}
    >
      <DropdownItemContent>{formatMessage(label)}</DropdownItemContent>
    </DropdownItem>
  );

  return (
    <DropdownMenu
      testId="privacyDropdown"
      shouldRenderToParent
      shouldFitContainer
      spacing="compact"
      trigger={({ triggerRef, ...props }) => (
        <Button
          {...props}
          shouldFitContainer
          iconAfter={ChevronDownIcon}
          ref={triggerRef}
        >
          {getTriggerMessage()}
        </Button>
      )}
    >
      <DropdownItemGroup>
        {allowEmptyChoice && getItem(null, messages.all)}
        {getItem(Privacy.public, messages.public)}
        {getItem(Privacy.private, messages.private)}
      </DropdownItemGroup>
    </DropdownMenu>
  );
};

// eslint-disable-next-line import/no-default-export
export default PrivacyDropdown;
